export default __webpack_public_path__ + "static/media/f2.62198d5f.jpg";